import type { RouteRecordRaw } from 'vue-router';

export const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('./pages/LoginPage.vue'),
  meta: {
    layout: 'empty',
    public: true,
  },
};

export const magicLinkRoute: RouteRecordRaw = {
  path: '/magic-link',
  name: 'MagicLink',
  component: () => import('./pages/MagicLinkPage.vue'),
  meta: {
    layout: 'empty',
    public: true,
  },
};

export const editMeRoute: RouteRecordRaw = {
  path: '/me/edit',
  name: 'EditMe',
  component: () => import('./pages/EditMePage.vue'),
  meta: {
    layout: 'main',
  },
};

export const notificationSettingsRoute: RouteRecordRaw = {
  path: '/me/notifications',
  name: 'NotificationSettings',
  component: () => import('./pages/NotificationSettingsPage.vue'),
  meta: {
    layout: 'main',
  },
};
